import { render, staticRenderFns } from "./GlobalTextEditor.vue?vue&type=template&id=c95bf258"
import script from "./GlobalTextEditor.vue?vue&type=script&lang=js"
export * from "./GlobalTextEditor.vue?vue&type=script&lang=js"
import style0 from "./GlobalTextEditor.vue?vue&type=style&index=0&id=c95bf258&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports